<template>
  <div class="progress-dots">
    <div
      v-for="(item, index) in totalSteps"
      :key="index"
      class="progress-item"
      :class="{
        circle: variant === 'circle',
        step: variant === 'step',
        active: index < currentStep,
      }"
      :style="itemStyles"
    ></div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ProgressDots',
  props: {
    currentStep: {
      type: Number,
      default: 1,
      validator: value => value >= 0,
    },
    totalSteps: {
      type: Number,
      default: 3,
      validator: value => value > 0,
    },
    variant: {
      type: String,
      default: 'circle',
      validator: value => ['circle', 'step'].includes(value),
    },
    size: {
      type: Number,
      default: 12,
    },
    stepWidth: {
      type: Number,
      default: 45.66,
    },
    gap: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    itemStyles() {
      if (this.variant === 'circle') {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
          borderRadius: '50%',
        };
      }
      return {
        width: `${this.stepWidth}px`,
        height: `${this.size}px`,
        borderRadius: '6px',
      };
    },
  },
};
</script>

<style scoped>
.progress-dots {
  display: flex;
  align-items: center;
  gap: v-bind(`${gap}px`);
}

.progress-item {
  background-color: #eeeeee;
  transition: background-color 0.3s ease;
}

.progress-item.active {
  background-color: #492b7c;
}

.progress-item.circle {
}

.progress-item.step {
}
</style>
